export const initialNotes = `
Senior/-in //  Senioren:

Wohnsituation:

Wünsche bzgl. BK:

Selbständige BK JA/NEIN:

Preiskalkulation:

Gewünschter Start:

Pause:

Infos zu den Betreuungskräften:

Sonderabsprachen:

Zum Preis:

Zur Betreuung:

Zur Wechselplanung:


Übernachtung von zwei Betreuungskräften möglich:

Sonstiges:



Preiserhöhungen:

`;

export const initialContractNotes = `
Startdatum:
Budget:
Provi:

Netzwerk/Pflegedienst:

Führerschein:

Rauchen:

Freitext:

`;
